module.exports = __webpack_public_path__ + "static/Kaizen_MetaisBasicosAS_Mitigacao-6e8ff15bfbe40d9b50d1b969affe76df.jpg";